import React from 'react';
import ReactDOM from 'react-dom';
import { init } from '@emailjs/browser';

import App from './App';
import './index.css';

init(process.env.REACT_APP_EMAILJS_USER_ID);
ReactDOM.render(<App />, document.getElementById('root'));